'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SESSION_TIMEOUT_WARNING_REDIRECT_URL_RHW = '/renter-hub/applications/session-timeout';

var SESSION_TIMEOUT_WARNING_REDIRECT_URL_RMW = '/rental-manager/applications/session-timeout';

var USER_TYPE_RENTER = 'renter-hub';

function getRedirectUrl(userType) {
    if (userType.includes(USER_TYPE_RENTER)) {
        return SESSION_TIMEOUT_WARNING_REDIRECT_URL_RHW;
    }
    // user type is landlord
    return SESSION_TIMEOUT_WARNING_REDIRECT_URL_RMW;
}

exports.getRedirectUrl = getRedirectUrl;